import Vue from 'vue'
import VueRouter from 'vue-router'

// 进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import store from '@/store/index'
import util from '@/libs/util.js'

// 路由数据
import routes from './routes'

import { loadLanguageAsync } from '@/i18n'
import i18n from '@/i18n'

import { getToken } from '@/libs/util.token'

// fix vue-router NavigationDuplicated
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return VueRouterPush.call(this, location).catch((err) => err)
}
const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  const from = this.currentRoute
  return VueRouterReplace.call(this, location)
    .then(() => {
      // 关闭上一个页面tab
      store.dispatch('admin/page/close', {
        tagName: from.fullPath,
        showConfirm: false
      })
    })
    .catch((err) => err)
}

Vue.use(VueRouter)

// 导出路由 在 main.js 里使用
const router = new VueRouter({
  base: process.env.VUE_APP_PUBLIC_PATH || null,
  mode: 'history',
  routes
})

/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach(async (to, from, next) => {
  var promises = [
    loadLanguageAsync({
      funcID: 'INDEX',
      curLanguage: i18n.locale
    }),
    loadLanguageAsync({
      funcID: to.meta.funcID,
      curLanguage: i18n.locale
    })
  ]

  Promise.all(promises).then(() => {
    // 进度条
    NProgress.start()

    // 验证当前路由所有的匹配中是否需要有登录验证的
    if (to.matched.some((r) => r.meta.auth)) {
      // 这里暂时将cookie里是否存有token作为验证是否登录的条件
      // 请根据自身业务需要修改
      const token = getToken()
      if (token && token !== 'undefined') {
        next()
      } else {
        // 没有登录的时候跳转到登录界面
        // 携带上登陆成功之后需要跳转的页面完整路径
        next({
          name: 'login',
          query: {
            redirect: to.fullPath
          }
        })
        NProgress.done()
      }
    } else {
      // 不需要身份校验 直接通过
      next()
    }
  })
})

router.afterEach((to, from) => {
  // 进度条
  NProgress.done()
  // await setBtnFunc(to)
  openTab(to, from)
  // 更改标题
  const title =
    typeof to.meta.title === 'function'
      ? to.meta.title({ $route: to })
      : to.meta.title
  util.title(title)
})

const openTab = (to) => {
  store.dispatch('admin/page/open', to)
}
// const setBtnFunc = async (to) => {
//   const funcID = to.meta.funcID
//   const menuMap = store.state.admin.menu.menuMap || {}
//   const menu = menuMap[funcID]
//   const getBtnFunc = menu ? menu.btnFunc || [] : []
//   await store.dispatch('admin/permission/btnRoleSet', getBtnFunc)
// }

export default router
